<template>
  <svg :width="width" :height="height" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.75 0.25C10.164 0.25 10.5 0.586 10.5 1V2.5H14.25C14.664 2.5 15 2.836 15 3.25V13C15 13.414 14.664 13.75 14.25 13.75H0.75C0.336 13.75 0 13.414 0 13V3.25C0 2.836 0.336 2.5 0.75 2.5H4.5V1C4.5 0.586 4.836 0.25 5.25 0.25H9.75ZM10.5 4H4.5V12.25H10.5V4ZM1.5 4V12.25H3V4H1.5ZM9 1.75H6V2.5H9V1.75ZM12 4V12.25H13.5V4H12Z" :fill="color"/>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({
  name: 'WcIconSuitcase',
  components: {}
})
export default class WcIconCircleCheck extends Vue {
  @Prop({ default: '16' }) width!: string;
  @Prop({ default: '16' }) height!: string;
  @Prop({ default: '#000000' }) color!: string
}
</script>

<style scoped>
</style>
